module.exports = __webpack_public_path__ + "static/media/CurrentLocation.5d42fe25.svg";